// src/api/inventoryService.js v07 from v06   Oct 18, 2025 05:43 - Pagination for Inventory list, supplier list 
/*
src/api/inventoryService.js v06 from v05   Oct 13, 2025 16:16 
src/api/inventoryService.js v05 from v04   OCt 7, 2025 18:43
*/
import { callCloudFunction } from './apiClient';

export const getInventoryItems = async (token, tenantid, page = 1, limit = 20) => {
    // return callCloudFunction('getInventoryItems', 'GET', null, null, token, null, { pathParams: {tenantid} });  // v05
    return callCloudFunction('inventoryCrud', 'GET', null, null, token, null, {
        pathParams: { tenantid, operation: 'list' },
        queryParams: { page, limit } // NEW: Ver07
    });
};

export const getInventoryItemById = async (id, token, tenantid) => {
//    return callCloudFunction('getInventoryItemById', 'GET', null, null, token, null, {pathParams: { tenantid, id } } );  // v05
    return callCloudFunction('inventoryCrud', 'GET', null, null, token, null, {
        pathParams: { tenantid, operation: 'getById', id }
    }); // v06
};

export const addInventoryItem = async (itemData, token, tenantid) => {
    // return callCloudFunction('addItem', 'POST', itemData, null, token, null, { pathParams: {tenantid} });  // v05
    return callCloudFunction('inventoryCrud', 'POST', itemData, null, token, null, {
        pathParams: { tenantid, operation: 'add' }
    });
}; // v06

export const updateInventoryItem = async (id, itemData, token, tenantid) => {
//    return callCloudFunction('updateItem', 'PUT', itemData, null, token, null, {pathParams: { tenantid, id } });  // v05
    return callCloudFunction('inventoryCrud', 'PUT', itemData, null, token, null, {
        pathParams: { tenantid, operation: 'update', id }
    });
}; // v06